/* eslint-disable max-lines */
import dayjs from 'dayjs';
import queryString from 'querystring';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { setMerchantNotOboardListFilter } from '../../../pages/MerchantNotOnboarding/actions';
import { removeDuplicateDataAob } from '../../../utils/builder/common';
import Filter from '../../elements/Filter';
import {
  fetchAgen,
  fetchCities,
  fetchDistricts,
  fetchProvinces,
  fetchRegionals,
  fetchSam,
  fetchSbm,
  fetchVillages,
} from '../../layouts/PageBase/actions';
import { dataWave } from '../AktivasiManualFilter/constant';
import { defaultDateRange, Fields, initialValues } from './fields';
import styles from './styles.scoped.css';

function MerchantNotOnboardFilter() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const {
    table: { filter: values },
  } = useSelector((state) => state.merchantNotOnboard);
  const {
    dataRegionals,
    dataProvinces,
    dataCities,
    dataDistricts,
    dataVillages,
    dataAgents,
    dataSbm,
    dataSam,
    dataDetailUser: {
      regionalId,
      regionalName,
      provinceId,
      cityId,
      cities,
      districtId,
      sam,
      sbm,
      villageId,
    },
  } = useSelector((state) => state.pageBase);

  const [selectedTemp, setSelectedTemp] = useState({
    cityId: [],
    districtId: [],
    villageId: [],
    sbmId: [],
  });
  const [valueDate, setValueDate] = useState(defaultDateRange);

  const query = queryString.parse(location.search.replace('?', ''));

  const dropdownData = {
    regional: regionalId
      ? [{ label: regionalName, value: regionalId }]
      : [
        { value: '*', label: 'Semua Regional' },
        ...dataRegionals.filter((item) => item.value !== ''),
      ],
    provinces: [
      { value: '*', label: 'Semua Provinsi' },
      ...dataProvinces.filter((item) => item.value !== ''),
    ],
    cities: [
      { label: 'Semua Kota/Kab', value: '*' },
      ...dataCities.filter((item) => item.value !== ''),
    ],
    districts: [
      { value: '*', label: 'Semua Kecamatan' },
      ...dataDistricts.filter((item) => item.value !== ''),
    ],
    villages: [
      { value: '', label: 'Semua Kelurahan' },
      ...dataVillages.filter((item) => item.value !== ''),
    ],
    suspendStatus: [
      { value: '', label: 'Semua Status' },
      { value: 'ACTIVE', label: 'Aktif' },
      { value: 'SUSPEND', label: 'Suspend' },
    ],
    agents: [{ value: '', label: 'Semua Agen' }, ...dataAgents],
    waves: dataWave,
    sam: sam?.id
      ? [{ value: sam?.id, label: sam?.name }]
      : [{ value: '*', label: 'Semua SAM' }, ...dataSam],
    sbm: sbm?.id
      ? [{ value: sbm?.id, label: sbm?.name }]
      : [{ value: '*', label: 'Semua SBM' }, ...dataSbm],
  };

  const handleGetAdministrativeArea = (name, params) => {
    if (name === 'agendId') {
      dispatch(fetchAgen());
    }

    const payloadProvince = {
      regional: params?.regional,
      samId: params?.samId,
    };
    const payloadCity = {
      ...payloadProvince,
      provinceId: params?.provinceId,
      sbmId: params?.sbmId,
    };
    const payloadDistrict = {
      ...payloadCity,
      cityId: params?.cityId,
    };
    const payloadVillage = {
      ...payloadDistrict,
      districtId: params?.districtId,
    };

    if (name === 'regional') {
      dispatch(fetchProvinces(payloadProvince));
      dispatch(fetchCities(payloadCity, selectedTemp.cityId));
      dispatch(fetchDistricts(payloadDistrict, selectedTemp.districtId));
      dispatch(fetchVillages(payloadVillage, selectedTemp.villageId));
      dispatch(fetchSbm(payloadProvince, selectedTemp.sbmId));
      dispatch(fetchSam({ regional: params?.regional }));
    }
    if (name === 'provinceId') {
      dispatch(fetchCities(payloadCity, selectedTemp.cityId));
      dispatch(fetchDistricts(payloadDistrict, selectedTemp.districtId));
      dispatch(fetchVillages(payloadVillage, selectedTemp.villageId));
    }
    if (name === 'cityId') {
      dispatch(fetchDistricts(payloadDistrict, selectedTemp.districtId));
      dispatch(fetchVillages(payloadVillage, selectedTemp.villageId));
    }
    if (name === 'districtId') {
      dispatch(fetchVillages(payloadVillage, selectedTemp.villageId));
    }

    if (name === 'sam') {
      dispatch(fetchSbm(payloadProvince, selectedTemp.sbmId));
      dispatch(fetchProvinces(payloadProvince));
      dispatch(fetchCities(payloadCity, selectedTemp.cityId));
      dispatch(fetchDistricts(payloadDistrict, selectedTemp.districtId));
      dispatch(fetchVillages(payloadVillage, selectedTemp.villageId));
    }

    if (name === 'sbm') {
      dispatch(fetchCities(payloadCity, selectedTemp.cityId));
      dispatch(fetchDistricts(payloadDistrict, selectedTemp.districtId));
      dispatch(fetchVillages(payloadVillage, selectedTemp.villageId));
    }
  };

  const handleGetAgents = (e) => {
    dispatch(fetchAgen(e.target.value));
  };

  const handleChangeValues = ({ name, value }) => {
    let filter = {};
    if (name === 'regional') {
      filter = {
        ...values,
        [name]: value !== '*' && value.length > 0 ? JSON.stringify(value) : '',
        provinceId: '',
        cityId: '',
        districtId: '',
        villageId: '',
        samId: sam?.id ? JSON.stringify([sam?.id]) : '',
        sbmId: sbm?.id ? JSON.stringify([sbm?.id]) : '',
      };
    } else if (name === 'provinceId') {
      filter = {
        ...values,
        regional: regionalId ? JSON.stringify([regionalId]) : values.regional,
        [name]: value !== '*' && value.length > 0 ? JSON.stringify(value) : '',
        cityId: '',
        districtId: '',
        villageId: '',
        samId: sam?.id ? JSON.stringify([sam?.id]) : values.samId,
        sbmId: sbm?.id ? JSON.stringify([sbm?.id]) : values.sbmId,
      };
    } else if (name === 'cityId') {
      filter = {
        ...values,
        [name]: value !== '*' && value.length > 0 ? JSON.stringify(value) : '',
        districtId: '',
        villageId: '',
      };
      const originDataTemp = [
        ...selectedTemp.cityId.filter((row) => value.includes(row.value)),
        ...dataCities.filter((row) => value.includes(row.value)),
      ];
      setSelectedTemp((val) => {
        return {
          ...val,
          cityId: removeDuplicateDataAob(originDataTemp, 'value'),
        };
      });
    } else if (name === 'districtId') {
      filter = {
        ...values,
        [name]: value !== '*' && value.length > 0 ? JSON.stringify(value) : '',
        villageId: '',
      };
      const originDataTemp = [
        ...selectedTemp.districtId.filter((row) => value.includes(row.value)),
        ...dataDistricts.filter((row) => value.includes(row.value)),
      ];
      setSelectedTemp((val) => {
        return {
          ...val,
          districtId: removeDuplicateDataAob(originDataTemp, 'value'),
        };
      });
    } else if (name === 'villageId') {
      filter = {
        ...values,
        [name]: value.length > 0 ? JSON.stringify(value) : '',
      };
      const originDataTemp = [
        ...selectedTemp.villageId.filter((row) => value.includes(row.value)),
        ...dataVillages.filter((row) => value.includes(row.value)),
      ];
      setSelectedTemp((val) => {
        return {
          ...val,
          villageId: removeDuplicateDataAob(originDataTemp, 'value'),
        };
      });
    } else if (name === 'sam') {
      filter = {
        ...values,
        regional: regionalId ? JSON.stringify([regionalId]) : values.regional,
        samId: value !== '*' && value.length > 0 ? JSON.stringify(value) : '',
        sbmId: sbm?.id ? JSON.stringify([sbm?.id]) : '',
        provinceId: '',
        cityId: '',
        districtId: '',
        villageId: '',
      };
    } else if (name === 'sbm') {
      filter = {
        ...values,
        regional: regionalId ? JSON.stringify([regionalId]) : values.regional,
        samId: sam?.id ? JSON.stringify([sam?.id]) : values.samId,
        sbmId: value !== '*' && value.length > 0 ? JSON.stringify(value) : '',
        cityId: '',
        districtId: '',
        villageId: '',
      };
      const originDataTemp = [
        ...selectedTemp.sbmId.filter((row) => value.includes(row.value)),
        ...dataSbm.filter((row) => value.includes(row.value)),
      ];
      setSelectedTemp((val) => {
        return {
          ...val,
          sbmId: removeDuplicateDataAob(originDataTemp, 'value'),
        };
      });
    } else if (name === 'registrationDate') {
      const startDate = value[0] ? dayjs(value[0]).format('YYYY-MM-DD') : '';
      const endDate = value[1] ? dayjs(value[1]).format('YYYY-MM-DD') : '';
      filter = { ...values, [name]: value, startDate, endDate };
    } else {
      filter = { ...values, [name]: value };
    }

    const newQuery = queryString.stringify({ ...query, ...filter });
    navigate(`?${newQuery}`);
    handleGetAdministrativeArea(name, filter);
    dispatch(setMerchantNotOboardListFilter(filter));
  };

  const handleReset = () => {
    const filter = {
      ...initialValues,
      regional: regionalId ? JSON.stringify([regionalId]) : '',
      provinceId: provinceId || '',
      cityId: cityId || '',
      districtId: districtId || '',
      villageId: villageId || '',
      samId: sam?.id ? JSON.stringify([sam?.id]) : '',
      sbmId: sbm?.id ? JSON.stringify([sbm?.id]) : '',
    };
    dispatch(setMerchantNotOboardListFilter(filter));
    navigate('?');
  };

  const handleSearchFilter = (value, name) => {
    if (regionalId !== undefined) {
      const payloadProvince = {
        regional: regionalId ? JSON.stringify([regionalId]) : query?.regional,
        samId: sam?.id ? JSON.stringify([sam?.id]) : query?.samId,
      };

      const payloadCity = {
        ...payloadProvince,
        provinceId: query?.provinceId?.length > 4 ? query?.provinceId : '',
        sbmId: sbm?.id ? JSON.stringify([sbm?.id]) : query?.sbmId,
        search: value,
      };
      const payloadDistrict = {
        ...payloadCity,
        cityId: query?.cityId?.length > 4 ? query?.cityId : '',
      };
      const payloadVillage = {
        ...payloadDistrict,
        districtId: query?.districtId?.length > 4 ? query?.districtId : '',
      };
      if (name === 'cities') {
        dispatch(fetchCities(payloadCity, selectedTemp.cityId));
      }
      if (name === 'districts') {
        dispatch(fetchDistricts(payloadDistrict, selectedTemp.districtId));
      }
      if (name === 'villages') {
        dispatch(fetchVillages(payloadVillage, selectedTemp.villageId));
      }
      if (name === 'sbm') {
        dispatch(
          fetchSbm(
            { ...payloadProvince, search: value },
            selectedTemp.sbmIdcityId
          )
        );
      }
    }
  };

  useEffect(() => {
    if (regionalId !== undefined) {
      dispatch(fetchRegionals());
      dispatch(fetchAgen());
      const newQuery = {
        ...values,
        regional: regionalId ? JSON.stringify([regionalId]) : '',
        provinceId: '',
        cityId: '',
        districtId: '',
        villageId: '',
        samId: sam?.id ? JSON.stringify([sam?.id]) : '',
        sbmId: sbm?.id ? JSON.stringify([sbm?.id]) : '',
      };
      dispatch(setMerchantNotOboardListFilter(newQuery));
      handleGetAdministrativeArea('regional', newQuery);
    }
  }, [regionalId]);

  return (
    <Filter
      className={styles.fields}
      fields={Fields({
        values,
        handleChangeValues,
        handleGetAgents,
        dropdownData,
        regionalId,
        provinceId,
        cityId,
        cities,
        handleSearchFilter,
        sam,
        sbm,
        setValueDate,
        valueDate,
      })}
      handleReset={handleReset}
    />
  );
}

export default MerchantNotOnboardFilter;
